import { render, staticRenderFns } from "./WeChatApplication.vue?vue&type=template&id=977c7ab6&scoped=true"
import script from "./WeChatApplication.vue?vue&type=script&lang=js"
export * from "./WeChatApplication.vue?vue&type=script&lang=js"
import style0 from "./WeChatApplication.vue?vue&type=style&index=0&id=977c7ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977c7ab6",
  null
  
)

export default component.exports